import {
  IQuoteContactAddressDataSchema,
  LegalEntityAddressFormatEnum,
} from '@monetize/types/app';
import { FunctionComponent as FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { MBox } from '../../../../../components/Monetize';
import QuoteContactsAddressItem from './QuoteContactsAddressItem';

interface QuoteContactsAddressListProps {
  isDisabled?: boolean;
  billingAccountId: string;
  shippingAccountId: string;
  addressDataForm: UseFormReturn<IQuoteContactAddressDataSchema>;
  addressFormat?: LegalEntityAddressFormatEnum | null;
}

const QuoteContactsAddressList: FC<QuoteContactsAddressListProps> = ({
  isDisabled = false,
  billingAccountId,
  shippingAccountId,
  addressDataForm,
  addressFormat = LegalEntityAddressFormatEnum.US_FORMAT,
}: QuoteContactsAddressListProps) => {
  const {
    formState: { errors },
    control,
  } = addressDataForm;
  return (
    <MBox>
      <QuoteContactsAddressItem
        label="Shipping Address"
        subLabel="Account Shipping Address"
        isDisabled={isDisabled}
        accountId={shippingAccountId}
        addressDataForm={addressDataForm}
        addressFormat={addressFormat}
        name="shippingAddressId"
      />
      <QuoteContactsAddressItem
        label="Billing Address"
        subLabel="Account Billing Address"
        isDisabled={isDisabled}
        accountId={billingAccountId}
        addressDataForm={addressDataForm}
        addressFormat={addressFormat}
        name="billingAddressId"
      />
    </MBox>
  );
};

export default QuoteContactsAddressList;
